<template>
<div class="sidebar" :class="{'togglebar': !isMenu}">
  <slot> </slot>
  </div>
</template>

<script>
'use strict';
export default {
  name: 'sidebar',
  created() {
      document.addEventListener("click", () => {this.onDocClick()} )
  },

  destroyed() {
    document.removeEventListener("click", () => {this.onDocClick()} )
  },

  data() {
    return {
      isMenu: false,

    }
  },
  methods: {
    onDocClick () {
      if (this.isMenu) {
      this.isMenu = false;
      }
    },
toggle () {
  if (this.isMenu) {
    this.isMenu = false;
  } else {
    this.isMenu = true;
  }
}
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebar {
  background: black;
  display: inline-block;
  color: white;
  position: fixed;
  right: 0;
/*top:4.7em;*/
height: 100vh !important;
 z-index: 600 !important;
  /*box-shadow: 0 0 20px rgba(34, 36, 38, .15);*/
  box-shadow: 0 6px 12px rgba(0,0,0,0.176);
  width: auto;
  
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  padding-top: 1.5em;
}
.item {
 box-shadow:none !important;
}
.togglebar {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?e3ba0bc8